import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';


import { StatusBar, Style } from '@capacitor/status-bar';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerOptions, CapacitorBarcodeScannerTypeHintALLOption } from '@capacitor/barcode-scanner';
import { Constants } from '../utility/constants';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';

const openCapacitorSite = async () =>
{
    await Browser.open({ url: 'http://capacitorjs.com/' });
};


export type StatusBarType = 'dark' | 'light' | 'medium' | 'green' | 'orange';

@Injectable({
    providedIn: 'root'
})
export class NativeService
{

    constructor(
        private platform: Platform
    ) { }


    public currentColor: StatusBarType = "light";

    private isDarkModeEnabled(): boolean
    {
        try
        {
            return typeof document !== 'undefined' && document.documentElement.classList.contains('mc-dark');
        }
        catch
        {
            return false;
        }
    }

    public async setupStatusBar(color: StatusBarType = "light")
    {
        this.currentColor = color;
        if (!this.platform.is('hybrid'))
        {
            return;
        }

        const darkMode = this.isDarkModeEnabled();

        if (this.platform.is('android'))
        {
            const isAndroid16Plus = await this.devicePlatformMinVersion(16);
            if (isAndroid16Plus)
            {
                let styleToSet = darkMode ? Style.Dark : Style.Light
                switch (color)
                {
                    case "light":
                        styleToSet = darkMode ? Style.Dark : Style.Light
                        break;
                    case "dark":
                    case "medium":
                        styleToSet = Style.Dark;
                        break;
                    case "green":
                    case "orange":
                        styleToSet = darkMode ? Style.Light : Style.Dark;
                        break;
                }
                try
                {
                    await StatusBar.setStyle({ style: styleToSet });
                }
                catch { }
            }
        }

        if (this.platform.is('ios'))
        {
			StatusBar.setStyle({
				style: darkMode ? Style.Dark : ((color == "light") ? Style.Dark : Style.Light)
			});
        }
    }



    



    async deviceIsPlatforms(platforms: ('ios' | 'android' | 'web' | string)[]): Promise<boolean>
    {
        var deviceInfo = await Device.getInfo();
        var devicePlatform = deviceInfo.platform;
        return platforms.includes(devicePlatform);
    }

    // async devicePlatformMinVersion(version: number): Promise<boolean> {
    // 	var deviceInfo = await Device.getInfo();
    // 	var versionString = deviceInfo.osVersion;
    // 	var versionNumber = parseFloat(versionString);
    // 	return versionNumber >= version;
    // }

    async devicePlatformMinVersion(minVersion: number): Promise<boolean>
    {
        const { osVersion } = await Device.getInfo();
        return osVersion && parseInt(osVersion.split('.')[0], 10) >= minVersion;
    }

    async runBarcodeScanner(): Promise<string | null>
    {
        try
        {
            const options: CapacitorBarcodeScannerOptions = {
                hint: CapacitorBarcodeScannerTypeHintALLOption.ALL
            };

            const result = await CapacitorBarcodeScanner.scanBarcode(options);
            if (result?.ScanResult)
            {
                // console.log('Scanned barcode:', result.ScanResult);
                return result.ScanResult;
            }

            return null;
        }
        catch (error)
        {
            console.error('Scanning failed:', error);
            throw error;
        }
    }
}
